<template>
  <ui-selectbox
    id="signUpTimezone"
    :width="width"
    :maxHeight="200"
    :value="value"
    :items="items"
    :disabled="disabled"
    :placeholder="placeholder"
    @input="onTimezoneChange"/>
</template>

<script>
import timezones from 'google-timezones-json'
import UiSelectbox from './UiSelectbox'
import { getOffset } from '@/libs/utils'

export default {
  name: 'TimezoneSelectbox',
  components: {
    UiSelectbox
  },
  props: [
    'value',
    'width',
    'disabled',
    'placeholder'
  ],
  computed: {
    items () {
      return Object.entries(timezones).filter(([key, value]) => {
        return value.substr(4, 6).split(':')[1] === '00' && key !== 'Asia/Yuzhno-Sakhalinsk'
      }).map(([key, value]) => {
        if (value.substr(4, 6).split(':')[1] === '00') {
          return {
            value: key,
            text: `(${getOffset(key)}) ${key}`
          }
        }
      }).sort((a, b) => {
        return a.text.localeCompare(b.text)
      })
    }
  },
  methods: {
    onTimezoneChange (value) {
      this.$emit('change', {
        timezone: getOffset(value),
        timezoneName: value
      })
    }
  }
}
</script>

<style>

</style>
